import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    const pixelId = '1927478928649366';
    // Initialize fbq function
    if (!(window as any).fbq) {
      const n: any = (window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Load the pixel script safely
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
    // Noscript fallback pixel
    const noscript = document.createElement('img');
    noscript.height = 1;
    noscript.width = 1;
    noscript.style.display = 'none';
    noscript.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    document.body.appendChild(noscript);
    return () => {
      if (noscript.parentNode) {
        noscript.parentNode.removeChild(noscript);
      }
    };
  }, []);
  return <SalesPage data-id="element-0" />;
}